import { render, staticRenderFns } from "./scroll-editor.vue?vue&type=template&id=63a9378a&scoped=true&"
import script from "./scroll-editor.vue?vue&type=script&lang=ts&"
export * from "./scroll-editor.vue?vue&type=script&lang=ts&"
import style0 from "./scroll-editor.vue?vue&type=style&index=0&id=63a9378a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63a9378a",
  null
  
)

export default component.exports